(function($) {
    'use strict';

    $(document).ready(function() {
        const $slider = $('#ba-slider');
        const $beforeWrap = $('#before-img-wrap');
        const $beforeImg = $beforeWrap.find('img');
        const $handle = $('#ba-handle');

        if (!$slider.length) return;

        let isResizing = false;

        function updatePosition(x) {
            const containerRect = $slider[0].getBoundingClientRect();
            let position = ((x - containerRect.left) / containerRect.width) * 100;

            // Constrain
            if (position < 0) position = 0;
            if (position > 100) position = 100;

            $beforeWrap.css('width', position + '%');
            $handle.css('left', position + '%');
        }

        function setImgWidth() {
            const containerWidth = $slider.width();
            $beforeImg.css('width', containerWidth + 'px');
        }

        $(window).on('resize', setImgWidth);
        setImgWidth();

        $slider.on('mousedown touchstart', function(e) {
            isResizing = true;
        });

        $(window).on('mouseup touchend', function() {
            isResizing = false;
        });

        $(window).on('mousemove touchmove', function(e) {
            if (!isResizing) return;

            let x;
            if (e.type === 'touchmove') {
                x = e.originalEvent.touches[0].pageX;
            } else {
                x = e.pageX;
            }

            updatePosition(x);
        });

        // Initialize at 50%
        updatePosition($slider[0].getBoundingClientRect().left + ($slider.width() / 2));
    });

})(jQuery);
